<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Configurar credenciais</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
    <div class="mb-5">
      <label for="sandbox" class="block text-sm font-medium"
        >Modo sandbox</label
      >
      <input id="sandbox" type="checkbox" formControlName="sandbox" />
    </div>
    <!-- pixKey -->
    <fieldset [formGroupName]="'in'">
      <legend class="block text-sm font-medium">Cash in</legend>

      <div class="mb-2">
        <label for="pixKey" class="block text-sm font-medium">PIX Key</label>
        <input
          id="pixKey"
          type="text"
          class="form-control"
          formControlName="pixKey"
          placeholder="Sua chave PIX"
        />
        <small
          *ngIf="form.get('pixKey')?.invalid && form.get('pixKey')?.touched"
          class="text-red-600"
        >
          Informe a chave PIX.
        </small>
      </div>

      <!-- clientKey (string) -->
      <div class="mb-2">
        <label for="clientKey" class="block text-sm font-medium"
          >Client Key</label
        >
        <input
          id="clientKey"
          type="text"
          class="form-control"
          formControlName="clientKey"
          placeholder="ex.: USR_API_..."
          autocomplete="off"
        />
        <small
          *ngIf="
            form.get('clientKey')?.invalid && form.get('clientKey')?.touched
          "
          class="text-red-600"
        >
          Informe o Client Key.
        </small>
      </div>

      <!-- clientSecret (string) -->
      <div class="mb-2">
        <label for="clientSecret" class="block text-sm font-medium"
          >Client Secret</label
        >
        <input
          id="clientSecret"
          [type]="showSecret ? 'text' : 'password'"
          class="form-control"
          formControlName="clientSecret"
          placeholder="Seu client secret"
          autocomplete="off"
        />
        <small
          *ngIf="
            form.get('clientSecret')?.invalid &&
            form.get('clientSecret')?.touched
          "
          class="text-red-600"
        >
          Informe o Client Secret.
        </small>
      </div>

      <hr class="my-4" />

      <!-- mtlsCert (file) -->
      <div class="mb-2">
        <label for="mtlsCertFile" class="block text-sm font-medium"
          >mTLS Certificate (arquivo .pem/.crt)</label
        >
        <input
          id="mtlsCertFile"
          type="file"
          class="form-control"
          (change)="onFileChange($event, 'mtlsCert')"
          accept=".pem,.crt,.cer,.txt"
        />
        <small class="text-gray-500" *ngIf="fileNames.mtlsCert">
          Selecionado: {{ fileNames.mtlsCert }}
        </small>
        <small
          *ngIf="form.get('mtlsCert')?.invalid && form.get('mtlsCert')?.touched"
          class="text-red-600"
        >
          Envie o certificado do cliente (mTLS).
        </small>
      </div>

      <!-- mtlsKey (file) -->
      <div class="mb-2">
        <label for="mtlsKeyFile" class="block text-sm font-medium"
          >mTLS Private Key (arquivo .key/.pem)</label
        >
        <input
          id="mtlsKeyFile"
          type="file"
          class="form-control"
          (change)="onFileChange($event, 'mtlsKey')"
          accept=".key,.pem,.txt"
        />
        <small class="text-gray-500" *ngIf="fileNames.mtlsKey">
          Selecionado: {{ fileNames.mtlsKey }}
        </small>
        <small
          *ngIf="form.get('mtlsKey')?.invalid && form.get('mtlsKey')?.touched"
          class="text-red-600"
        >
          Envie a chave privada (mTLS).
        </small>
      </div>

      <div class="mb-2">
        <label for="mtlsKeyFile" class="block text-sm font-medium"
          >mTLS Private Key (arquivo .pfx)</label
        >
        <input
          id="mtlsKeyFile"
          type="file"
          class="form-control"
          (change)="onFileChange($event, 'mtlsPfx')"
          accept=".pfx"
        />
        <small class="text-gray-500" *ngIf="fileNames.mtlsKey">
          Selecionado: {{ fileNames.mtlsKey }}
        </small>
        <small
          *ngIf="form.get('mtlsPfx')?.invalid && form.get('mtlsPfx')?.touched"
          class="text-red-600"
        >
          Envie a chave privada (PFX).
        </small>
      </div>

      <div class="mb-2">
        <label
          for="mtlsPassphrase
"
          class="block text-sm font-medium"
          >Cert Passphrase</label
        >
        <input
          id="mtlsPassphrase
"
          [type]="showSecret ? 'text' : 'password'"
          class="form-control"
          formControlName="mtlsPassphrase"
          placeholder="Seu cert passphrase"
          autocomplete="off"
        />
        <small
          *ngIf="
            form.get('mtlsPassphrase')?.invalid &&
            form.get('mtlsPassphrase')?.touched
          "
          class="text-red-600"
        >
          Informe o Client Secret.
        </small>
      </div>
    </fieldset>

    <fieldset class="mt-4" [formGroupName]="'out'">
      <legend class="block text-sm font-medium">Cash out</legend>
      <!-- clientKey (string) -->
      <div class="mb-2">
        <label for="clientKey" class="block text-sm font-medium"
          >Client Key</label
        >
        <input
          id="clientKey"
          type="text"
          class="form-control"
          formControlName="clientKey"
          placeholder="ex.: USR_API_..."
          autocomplete="off"
        />
        <small
          *ngIf="
            form.get('clientKey')?.invalid && form.get('clientKey')?.touched
          "
          class="text-red-600"
        >
          Informe o Client Key.
        </small>
      </div>

      <!-- clientSecret (string) -->
      <div class="mb-2">
        <label for="clientSecret" class="block text-sm font-medium"
          >Client Secret</label
        >
        <input
          id="clientSecret"
          [type]="showSecret ? 'text' : 'password'"
          class="form-control"
          formControlName="clientSecret"
          placeholder="Seu client secret"
          autocomplete="off"
        />

        <small
          *ngIf="
            form.get('clientSecret')?.invalid &&
            form.get('clientSecret')?.touched
          "
          class="text-red-600"
        >
          Informe o Client Secret.
        </small>
      </div>
    </fieldset>

    <button
      class="btn-send btn-primary"
      type="submit"
      [disabled]="form.invalid || submitting"
    >
      {{ submitting ? 'Enviando...' : 'Salvar' }}
    </button>
  </form>
</div>
